import React from "react";
import {AnimatePresence} from "framer-motion";

const ModalContainer = ({children}) => (
    <AnimatePresence initial={false} exitBeforeEnter={true}>
        {children}
    </AnimatePresence>
);

export default ModalContainer;